import React, {ChangeEvent, useState} from "react";
import {Button} from "@mui/material";

export interface UploadFileFieldProps {
    label: string;
    setFileToUpload: (file: File) => void;
}

export const UploadFileField: React.FC<UploadFileFieldProps> = ({label, setFileToUpload}) => {
    const [selectedFile, setSelectedFile] = useState<File|undefined>();

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        let files = event.target.files;

        if (files && files[0]) {
            setSelectedFile(files[0]);
            setFileToUpload(files[0]);
        }
    };

    return <>
        <Button variant="contained" component="label">
            {label}
            <input hidden accept=".csv" multiple type="file" onChange={handleChange}/>
        </Button>
        <label>{(selectedFile && selectedFile.name)}</label>
    </>;
};